module.exports = __webpack_public_path__ + "img/awards_image_07.1393b320.jpg";